import { Edit, Delete } from "@mui/icons-material";
import DateSettingDialog from "components/admin/DateSettingDialog";
import api from "config/api";
import { useEffect, useState } from "react";
import PlusOneSharp from "@mui/icons-material/Add";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import { toast } from "react-toastify";
import moment from "moment";

const RestDatesSetting = () => {
  const [datesData, setDatesData] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);
  const [restDateId, setRestDateId] = useState<boolean | number>(false);
  const [isMultiDatesAdd, setIsMultiDatesAdd] = useState(false);
  const [selectedData, setSelectedData] = useState<any>(undefined);

  const fetchData = () => {
    setLoading(true);
    api
      .get("api/RestDates/GetRestdates")
      .then(({ data }) => setDatesData(data))
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteDate = (id: number) => {
    setLoading(true);
    api
      .post(`api/RestDates/DeleteRestdate?id=${id}`)
      .then(({ data }) => {
        fetchData();
      })
      .catch((error) => toast.error(error))
      .finally(() => setLoading(false));
  };

  return (
    <div className="w-full flex flex-col p-4">
      <div className=" w-full flex justify-end items-center max-sm:flex-col max-sm:items-end gap-2 border-b-2 pb-2">
        <div className="border-2 rounded-lg flex  overflow-hidden cursor-pointer gap-2">
          <div
            className={`py-1 px-2 bg-primary !text-themeSelColor`}
            onClick={() => {
              setRestDateId(true);
              setIsMultiDatesAdd(true);
            }}
          >
            <LibraryAddIcon />
          </div>
          <div
            className={`py-1 px-2 bg-primary !text-themeSelColor`}
            onClick={() => {
              setRestDateId(true);
              setIsMultiDatesAdd(false);
            }}
          >
            <PlusOneSharp />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg mt-4 time-setting-table overflow-hidden">
        <table className="border-collapse w-full">
          <thead className="bg-primary text-themeSelColor py-2">
            <tr>
              <th className="text-start py-2 pl-4">Order Type</th>
              <th>From</th>
              <th>TO</th>
              <th className="py-2 pr-4">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {datesData?.map((item: any) => (
              <tr className="hover:bg-gray-200">
                <td className="text-start py-2 pl-4">{item.timdOrdtype}</td>
                <td className="text-center">{moment(item.timdFrom).format('YYYY/MM/DD')}</td>
                <td className="text-center">{moment(item.timdTo).format('YYYY/MM/DD')}</td>
                <td className="pr-4 py-2 cursor-pointer flex justify-center gap-3">
                  <div
                    className="flex justify-center"
                    onClick={() => {
                      setRestDateId(item.timdId);
                      setSelectedData(item);
                    }}
                  >
                    <Edit className="!text-[20px]" />
                  </div>
                  <div
                    className="flex justify-center"
                    onClick={() => {
                      deleteDate(item.timdId);
                    }}
                  >
                    <Delete className="!text-[20px] text-red-500" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {loading && (
          <div className="bg-white">
            {Array.from({ length: 7 }).map(() => (
              <div className="h-11 animate-pulse bg-gray-300 border-b"></div>
            ))}
          </div>
        )}
      </div>
      <DateSettingDialog
        open={!!restDateId}
        onClose={() => {
          setRestDateId(false);
          setIsMultiDatesAdd(false);
          setSelectedData(undefined)
        }}
        restDateId={restDateId}
        refetch={fetchData}
        isMultiDatesAdd={isMultiDatesAdd}
        selectedData={selectedData}
      />
    </div>
  );
};

export default RestDatesSetting;
